import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./AuthContext";

export function PrivateRoute() {
  const { token } = useAuth();
  return token ? <Outlet /> : <Navigate to="/auth/sign-in" replace />;
}

export function PublicOnlyRoute() {
  const { token } = useAuth();
  return token ? <Navigate to="/admin/default" replace /> : <Outlet />;
}
